var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglepanna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.293,0H119.708c-24.42,0.008-44.194,19.783-44.202,44.202v423.597 c0.008,24.419,19.783,44.193,44.202,44.202h272.585c24.418-0.008,44.193-19.783,44.202-44.202V44.202 C436.486,19.783,416.711,0.008,392.293,0z M392.293,490.311H119.708c-12.426-0.024-22.488-10.087-22.513-22.512V44.202 c0.025-12.425,10.087-22.488,22.513-22.512h272.585c12.425,0.024,22.488,10.087,22.512,22.512v423.597 C414.781,480.224,404.718,490.286,392.293,490.311z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.098,190.006c-21.575-17.15-51.722-5.133-58.102,18.846c-6.363-23.979-36.51-35.996-58.086-18.846 c-20.662,16.442-18.993,49.181,1.239,75.416c18.699,24.248,47.917,47.616,55.78,63.838l1.067,0.798l1.084-0.798 c7.863-16.223,37.08-39.591,55.78-63.838C333.091,239.187,334.753,206.449,314.098,190.006z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.625,60.327c-9.786-7.765-23.442-2.323-26.334,8.538c-2.876-10.861-16.532-16.304-26.318-8.538 c-9.354,7.455-8.612,22.276,0.562,34.163c8.474,11.008,21.714,21.584,25.274,28.925l0.481,0.366l0.497-0.366 c3.561-7.341,16.801-17.917,25.274-28.925C191.237,82.602,191.979,67.782,182.625,60.327z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.7,414.56c-2.876-10.861-16.531-16.304-26.317-8.538c-9.354,7.455-8.612,22.276,0.562,34.164 c8.473,11.007,21.706,21.583,25.274,28.924l0.48,0.366l0.498-0.366c3.561-7.341,16.801-17.917,25.274-28.924 c9.174-11.888,9.916-26.709,0.562-34.164C372.249,398.257,358.593,403.699,355.7,414.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglepanna);
export default __webpack_public_path__ + "static/media/singlepanna.2c0a3a79877806e2bb6fb0dd7e2bd890.svg";
export { ForwardRef as ReactComponent };